/* =========================================================================
   LUMINI KIDS – Theme-Verhalten
   Gleiche Interaktionen wie in der freigegebenen Demo (index.html),
   nur gegen die Shopify-Ajax-Schnittstellen statt gegen Demo-Daten.

   Erwartete globale Konfiguration (wird in layout/theme.liquid gesetzt):
     window.LUMINI = { routes: {...}, strings: {...}, freeShip: 8000, moneyFormat: '...' }
     Beträge kommen von Shopify immer in Rappen (Integer).
   ========================================================================= */
'use strict';

(function () {

  const CFG = window.LUMINI || {};
  const R = CFG.routes || {};
  const T = Object.assign({
    added: 'liegt im Warenkorb.',
    wishOn: 'Auf die Wunschliste gesetzt.',
    wishOff: 'Von der Wunschliste entfernt.',
    pickSize: 'Bitte wähle zuerst eine Grösse.',
    pickColor: 'Bitte wähle noch eine Farbe.',
    removed: 'Artikel entfernt.',
    cookieAll: 'Danke – alle Cookies erlaubt.',
    cookieMin: 'Alles klar, nur notwendige Cookies.',
    searchHint: 'Beliebt: Strampler · Samt-Set · Latzhose · Bademantel · Wickeldecke',
    noHits: 'Keine Treffer für „{q}“. Versuch es mit einem anderen Wort.',
    hits: '{n} Treffer für „{q}“'
  }, CFG.strings || {});

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ---------------------------------------------------------------- Geld */
  /* Shopify liefert Rappen. Die Demo zeigt „CHF 29.90“ und „CHF 80.–“. */
  function chf(cents) {
    const n = (cents || 0) / 100;
    return 'CHF ' + n.toFixed(2).replace('.00', '.–');
  }

  /* ------------------------------------------------------------- Overlays */
  const scrim = () => $('#scrim');

  function lock() {
    scrim().classList.add('is-on');
    document.body.classList.add('no-scroll');
  }

  function closeAll() {
    ['#cartDrawer', '#searchPanel', '#mobMenu', '#filters'].forEach(sel => {
      const el = $(sel);
      if (el) el.classList.remove('is-open');
    });
    scrim().classList.remove('is-on');
    document.body.classList.remove('no-scroll');
  }

  function openCart() { $('#cartDrawer').classList.add('is-open'); lock(); }
  function openMenu() { $('#mobMenu').classList.add('is-open'); lock(); }
  function openFilters() {
    const f = $('#filters');
    if (!f) return;
    f.classList.add('is-open');
    lock();
  }
  function openSearch() {
    $('#searchPanel').classList.add('is-open');
    lock();
    setTimeout(() => { const i = $('#searchInput'); if (i) i.focus(); }, 260);
  }

  /* --------------------------------------------------------------- Toasts */
  function toast(msg) {
    const box = $('#toasts');
    if (!box) return;
    const el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML = (CFG.checkIcon || '') + '<span>' + msg + '</span>';
    box.appendChild(el);
    setTimeout(() => { el.style.opacity = '0'; el.style.transform = 'translateY(10px)'; }, 2600);
    setTimeout(() => el.remove(), 3100);
  }

  /* ------------------------------------------------------------ Warenkorb */
  async function cartFetch(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    if (!res.ok) {
      let msg = 'Das hat nicht geklappt. Bitte versuch es nochmal.';
      try { const j = await res.json(); if (j.description) msg = j.description; } catch (e) {}
      throw new Error(msg);
    }
    return res.json();
  }

  function badge(el, n) {
    if (!el) return;
    el.textContent = n;
    el.classList.toggle('is-zero', n === 0);
  }

  function lineItemHTML(item) {
    const img = item.featured_image && item.featured_image.url
      ? `<img class="art" src="${item.featured_image.url}&width=200" alt="${escapeHTML(item.featured_image.alt || item.product_title)}" loading="lazy" decoding="async" style="object-fit:cover">`
      : (CFG.placeholder || '');
    const opts = (item.options_with_values || [])
      .filter(o => o.value && o.value !== 'Default Title')
      .map(o => escapeHTML(o.value)).join(' · ');
    const meta = [escapeHTML(item.vendor || ''), opts].filter(Boolean).join(' · ');
    return `<div class="line-item">
      <a class="line-thumb" href="${item.url}">${img}</a>
      <div>
        <div class="li-bottom" style="align-items:flex-start">
          <a href="${item.url}"><h4 class="li-name">${escapeHTML(item.product_title)}</h4></a>
          <strong style="font-size:13.5px">${chf(item.final_line_price)}</strong>
        </div>
        <p class="li-meta">${meta}</p>
        <div class="li-bottom">
          <div class="qty">
            <button data-cq="${item.key}" data-to="${item.quantity - 1}" aria-label="Weniger">&minus;</button>
            <span>${item.quantity}</span>
            <button data-cq="${item.key}" data-to="${item.quantity + 1}" aria-label="Mehr">+</button>
          </div>
          <button class="li-remove" data-cq="${item.key}" data-to="0">Entfernen</button>
        </div>
      </div>
    </div>`;
  }

  function renderCart(cart) {
    const body = $('#cartBody');
    const foot = $('#cartFoot');
    const n = cart.item_count;

    badge($('#cartBadge'), n);
    $$('[data-badge="cart"]').forEach(el => badge(el, n));

    if (!body || !foot) return;

    if (!n) {
      body.innerHTML = `<div class="empty">${CFG.bagIcon || ''}
        <h3 style="margin-bottom:8px">Dein Warenkorb ist leer</h3>
        <p>Leg ein Lieblingsstück hinein – wir heben es dir hier auf.</p>
        <a class="btn btn--sage" href="${R.collections || '/collections/all'}" data-close-cart style="margin-top:18px">Produkte entdecken</a></div>`;
      foot.innerHTML = '';
      return;
    }

    const free = CFG.freeShip || 8000;
    const rest = Math.max(0, free - cart.items_subtotal_price);

    body.innerHTML = `
      <div class="ship-bar">
        <p>${rest > 0
          ? `Noch <strong>${chf(rest)}</strong> bis zum kostenlosen Versand.`
          : 'Versand ist kostenlos. &#10003;'}</p>
        <div class="ship-track"><div class="ship-fill" style="width:${Math.min(100, cart.items_subtotal_price / free * 100)}%"></div></div>
      </div>
      ${cart.items.map(lineItemHTML).join('')}`;

    const discounts = (cart.cart_level_discount_applications || []).map(d =>
      `<div class="sum-row" style="color:var(--sage-dark)"><span>Rabatt ${escapeHTML(d.title)}</span><span>&minus;${chf(d.total_allocated_amount)}</span></div>`
    ).join('');

    foot.innerHTML = `
      <div class="sum-row"><span>Zwischensumme</span><span>${chf(cart.items_subtotal_price)}</span></div>
      ${discounts}
      <div class="sum-row"><span>Versand</span><span>${rest > 0 ? chf(CFG.shipFlat || 890) : 'Kostenlos'}</span></div>
      <div class="sum-row total"><span>Total</span><span>${chf(cart.total_price + (rest > 0 ? (CFG.shipFlat || 890) : 0))}</span></div>
      <a class="btn btn--sage btn--wide" href="${R.cart || '/cart'}" style="margin-top:18px">Zur Kasse</a>
      <p style="text-align:center;font-size:11.5px;color:var(--ink-faint);margin:12px 0 0">${escapeHTML(CFG.vatNote || '')}</p>`;
  }

  async function refreshCart() {
    try { renderCart(await cartFetch(R.cart + '.js')); } catch (e) { /* stumm: Badge bleibt wie es ist */ }
  }

  async function addToCart(variantId, qty, title) {
    try {
      await cartFetch(R.cartAdd || '/cart/add.js', { items: [{ id: Number(variantId), quantity: qty || 1 }] });
      await refreshCart();
      toast(`${title} ${T.added}`);
      openCart();
    } catch (e) {
      toast(e.message);
    }
  }

  async function changeLine(key, to) {
    try {
      renderCart(await cartFetch(R.cartChange || '/cart/change.js', { id: key, quantity: to }));
      if (to === 0) toast(T.removed);
    } catch (e) {
      toast(e.message);
    }
  }

  /* ----------------------------------------------------------- Wunschliste */
  const WISH_KEY = 'lumini:wish';
  const wishRead = () => { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; } };
  const wishWrite = a => { try { localStorage.setItem(WISH_KEY, JSON.stringify(a)); } catch (e) {} };

  function paintWish() {
    const list = wishRead();
    badge($('#wishBadge'), list.length);
    $$('[data-badge="wish"]').forEach(el => badge(el, list.length));
    $$('[data-wish]').forEach(btn => {
      const on = list.indexOf(btn.dataset.wish) > -1;
      btn.classList.toggle('is-on', on);
      const svg = btn.querySelector('svg');
      if (svg && btn.classList.contains('icon-btn')) {
        svg.setAttribute('fill', on ? '#C36A57' : 'none');
        svg.setAttribute('stroke', on ? '#C36A57' : 'currentColor');
      }
    });
    /* Auf der Wunschlistenseite die gemerkten Karten ein- und ausblenden */
    const page = $('[data-wishlist-page]');
    if (page) {
      let shown = 0;
      $$('[data-wish-card]', page).forEach(card => {
        const on = list.indexOf(card.dataset.wishCard) > -1;
        card.hidden = !on;
        if (on) shown++;
      });
      const empty = $('[data-wishlist-empty]', page);
      const grid = $('[data-wishlist-grid]', page);
      if (empty) empty.hidden = shown > 0;
      if (grid) grid.hidden = shown === 0;
    }
  }

  function toggleWish(handle) {
    const list = wishRead();
    const i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); toast(T.wishOff); }
    else { list.push(handle); toast(T.wishOn); }
    wishWrite(list);
    paintWish();
  }

  /* ------------------------------------------------------- Vorschlagssuche */
  let searchTimer;
  async function runSearch(q) {
    const res = $('#searchRes');
    const hint = $('#searchHint');
    q = q.trim();
    if (q.length < 2) { res.innerHTML = ''; hint.textContent = T.searchHint; return; }
    try {
      const url = `${R.predictiveSearch || '/search/suggest'}?q=${encodeURIComponent(q)}`
        + `&resources[type]=product&resources[limit]=5&section_id=predictive-search`;
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('[data-search-card]');
      res.innerHTML = Array.from(cards).map(c => c.outerHTML).join('');
      hint.textContent = cards.length
        ? T.hits.replace('{n}', cards.length).replace('{q}', q)
        : T.noHits.replace('{q}', q);
      paintWish();
    } catch (e) {
      hint.textContent = T.noHits.replace('{q}', q);
    }
  }

  /* ------------------------------------------------------------ Bausteine */
  function initAcc(root) {
    $$('.acc-item.is-open .acc-body', root).forEach(b => { b.style.maxHeight = b.scrollHeight + 'px'; });
  }

  let io;
  function initReveals(root) {
    const els = $$('.reveal:not(.in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('in')); return; }
    if (!io) {
      io = new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      }), { threshold: .12 });
    }
    els.forEach(e => io.observe(e));
  }

  function initSlider() {
    const sl = $('#slider');
    if (!sl) return;
    const step = () => sl.clientWidth / (window.innerWidth < 720 ? 1.4 : 2.2);
    const prev = $('#slPrev'), next = $('#slNext');
    if (prev) prev.onclick = () => sl.scrollBy({ left: -step(), behavior: 'smooth' });
    if (next) next.onclick = () => sl.scrollBy({ left: step(), behavior: 'smooth' });
  }

  /* --------------------------------------------------------- Produktseite */
  /* Die Variante ergibt sich aus den gewählten Optionswerten. Der Datensatz
     steht als JSON im Markup (siehe sections/main-product.liquid). */
  function initPDP() {
    const form = $('[data-pdp]');
    if (!form) return;

    let variants = [];
    try { variants = JSON.parse($('[data-variants]', form).textContent); } catch (e) { return; }

    const state = { qty: 1, opts: {} };
    const optNames = variants.length ? Object.keys(variants[0].options) : [];

    /* Vorauswahl: nur wenn es genau eine Möglichkeit gibt */
    optNames.forEach(name => {
      const values = [...new Set(variants.map(v => v.options[name]))];
      if (values.length === 1) state.opts[name] = values[0];
    });

    function current() {
      return variants.find(v => optNames.every(n => v.options[n] === state.opts[n])) || null;
    }

    function paint() {
      const v = current();

      $$('[data-opt]', form).forEach(btn => {
        btn.classList.toggle('is-on', state.opts[btn.dataset.opt] === btn.dataset.value);
      });
      $$('[data-opt-label]', form).forEach(el => {
        const n = el.dataset.optLabel;
        el.textContent = state.opts[n] ? el.dataset.prefix + ': ' + state.opts[n] : el.dataset.prefix;
      });

      const qtyEl = $('[data-qty-value]', form);
      if (qtyEl) qtyEl.textContent = state.qty;

      const btn = $('#pdpAdd', form);
      const stock = $('[data-stock]', form);
      const note = $('[data-size-note]', form);

      if (!v) {
        btn.textContent = 'Bitte Auswahl treffen';
        btn.disabled = false;
        if (note) note.hidden = true;
        return;
      }

      $('[data-variant-id]', form).value = v.id;

      if (v.available) {
        btn.disabled = false;
        btn.innerHTML = 'In den Warenkorb &nbsp;·&nbsp; ' + chf(v.price * state.qty);
      } else {
        btn.disabled = true;
        btn.textContent = 'Ausverkauft';
      }

      if (stock) {
        const s = !v.available
          ? { t: 'Momentan ausverkauft', c: '#6E675E' }
          : v.qty > 0 && v.qty <= 2
            ? { t: 'Nur noch wenige Stück an Lager', c: '#8A5C24' }
            : { t: 'An Lager – Versand in 1–2 Werktagen', c: 'var(--sage-ink)' };
        stock.style.color = s.c;
        stock.querySelector('.dot').style.background = s.c;
        stock.querySelector('[data-stock-text]').textContent = s.t;
      }

      if (note) {
        const show = v.available && v.qty > 0 && v.qty <= 2;
        note.hidden = !show;
        if (show) note.textContent = `Nur noch ${v.qty} Stück in dieser Auswahl.`;
      }

      /* Bild zur Variante mitziehen, wenn eines hinterlegt ist */
      if (v.image) {
        const thumb = $$('[data-img]', form).find(t => t.dataset.src === v.image);
        if (thumb) thumb.click();
      }
    }

    form.addEventListener('click', e => {
      const opt = e.target.closest('[data-opt]');
      if (opt) { state.opts[opt.dataset.opt] = opt.dataset.value; paint(); return; }

      const q = e.target.closest('[data-pqty]');
      if (q) { state.qty = Math.max(1, state.qty + Number(q.dataset.pqty)); paint(); return; }

      const img = e.target.closest('[data-img]');
      if (img) {
        $$('[data-img]', form).forEach(t => t.classList.remove('is-on'));
        img.classList.add('is-on');
        const main = $('[data-pdp-main]', form);
        if (main) main.innerHTML = img.innerHTML;
        return;
      }
    });

    form.addEventListener('submit', e => {
      e.preventDefault();
      const v = current();
      if (!v) { toast(optNames.length > 1 ? T.pickSize : T.pickSize); return; }
      if (!v.available) return;
      addToCart(v.id, state.qty, form.dataset.pdp);
    });

    paint();
  }

  /* ---------------------------------------------------------- Ereignisse */
  document.addEventListener('click', e => {
    const t = e.target;

    const wishBtn = t.closest('[data-wish]');
    if (wishBtn) { e.preventDefault(); toggleWish(wishBtn.dataset.wish); return; }

    const quick = t.closest('[data-quickadd]');
    if (quick) {
      e.preventDefault();
      if (quick.dataset.quickadd === 'choose') { window.location.href = quick.dataset.url; return; }
      addToCart(quick.dataset.quickadd, 1, quick.dataset.title || '');
      return;
    }

    const cq = t.closest('[data-cq]');
    if (cq) { changeLine(cq.dataset.cq, Number(cq.dataset.to)); return; }

    if (t.closest('#fToggle')) { openFilters(); return; }
    if (t.closest('#fClose') || t.closest('#fApply')) { closeAll(); return; }

    const acc = t.closest('.acc-head');
    if (acc) {
      const item = acc.parentElement, body = item.querySelector('.acc-body');
      const open = item.classList.toggle('is-open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      return;
    }

    if (t.closest('#btnCart')) { e.preventDefault(); openCart(); return; }
    if (t.closest('#btnSearch')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('#btnBurger')) { openMenu(); return; }
    if (t.closest('#btnCartClose') || t.closest('#scrim') || t.closest('#btnSearchClose') || t.closest('#btnMobClose')) {
      closeAll(); return;
    }
    if (t.closest('[data-close-cart]')) { setTimeout(closeAll, 10); return; }

    const op = t.closest('[data-open]');
    if (op) {
      const k = op.dataset.open;
      closeAll();
      setTimeout(() => { k === 'search' ? openSearch() : openCart(); }, 300);
      return;
    }
    if (t.closest('.mob a')) { closeAll(); return; }
    if (t.closest('#toTop')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }

    const ck = t.closest('[data-cookie]');
    if (ck) {
      $('#cookie').style.display = 'none';
      try { localStorage.setItem('lumini:cookie', ck.dataset.cookie); } catch (err) {}
      toast(ck.dataset.cookie === 'all' ? T.cookieAll : T.cookieMin);
      return;
    }
  });

  document.addEventListener('input', e => {
    if (e.target.id === 'searchInput') {
      clearTimeout(searchTimer);
      const v = e.target.value;
      searchTimer = setTimeout(() => runSearch(v), 220);
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeAll();
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      const b = $('#btnSearch');
      if (b) b.click();
    }
  });

  window.addEventListener('scroll', () => {
    const h = $('#header'), tt = $('#toTop');
    if (h) h.classList.toggle('is-stuck', window.scrollY > 8);
    if (tt) tt.classList.toggle('is-on', window.scrollY > 700);
  }, { passive: true });

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }

  /* -------------------------------------------------------------- Start */
  function init() {
    initReveals();
    initAcc();
    initSlider();
    initPDP();
    paintWish();
    refreshCart();

    let choice = null;
    try { choice = localStorage.getItem('lumini:cookie'); } catch (e) {}
    const cookie = $('#cookie');
    if (cookie && choice) cookie.style.display = 'none';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Der Theme-Editor tauscht Sections einzeln aus – danach neu verdrahten. */
  document.addEventListener('shopify:section:load', e => {
    initReveals(e.target);
    initAcc(e.target);
    initSlider();
    initPDP();
    paintWish();
  });

  window.LuminiTheme = { openCart, openSearch, closeAll, refreshCart, toast };

})();
